import { FC } from 'react';
import { TextKey } from '@mews-commander/enums';
import { Link } from '@optimus-web/core';
import { LocalizedTypography } from '../../localization/LocalizedTypography';

interface ExpandableLineTriggerTextProps {
    expanded: boolean;
    onClick: () => void;
}

export const ExpandableLineTriggerText: FC<ExpandableLineTriggerTextProps> = ({
    expanded,
    onClick,
}: ExpandableLineTriggerTextProps) => (
    <Link onClick={onClick} variant="basic" as="button">
        <LocalizedTypography textStyle="bodySmall" textKey={expanded ? TextKey.Hide : TextKey.Show} as="div" />
    </Link>
);
